var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeverityWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0504 2.59027C10.9467 2.41145 10.7946 2.26238 10.6098 2.15857C10.4251 2.05476 10.2145 2 10 2C9.7855 2 9.57492 2.05476 9.39018 2.15857C9.20545 2.26238 9.0533 2.41145 8.94959 2.59027L1.14948 16.3047C1.04861 16.4787 0.997133 16.6748 1.00012 16.8735C1.00311 17.0722 1.06047 17.2668 1.16653 17.438C1.27259 17.6091 1.42369 17.751 1.60491 17.8496C1.78613 17.9481 1.9912 18 2.19989 18H17.8001C18.0088 18 18.2139 17.9481 18.3951 17.8496C18.5763 17.751 18.7274 17.6091 18.8335 17.438C18.9395 17.2668 18.9969 17.0722 18.9999 16.8735C19.0029 16.6748 18.9514 16.4787 18.8505 16.3047L11.0504 2.59027Z",
    stroke: "#F2994A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.2666C10.0707 14.2666 10.1386 14.2947 10.1886 14.3447C10.2386 14.3947 10.2667 14.4625 10.2667 14.5333",
    stroke: "#F2994A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7334 14.5333C9.7334 14.4625 9.76149 14.3947 9.8115 14.3447C9.86151 14.2947 9.92934 14.2666 10.0001 14.2666",
    stroke: "#F2994A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 14.7999C9.92934 14.7999 9.86151 14.7718 9.8115 14.7218C9.76149 14.6718 9.7334 14.6039 9.7334 14.5332",
    stroke: "#F2994A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2667 14.5332C10.2667 14.6039 10.2386 14.6718 10.1886 14.7218C10.1386 14.7718 10.0707 14.7999 10 14.7999",
    stroke: "#F2994A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11L10 7",
    stroke: "#F2994A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeverityWarning);
export default __webpack_public_path__ + "static/media/SeverityWarning.543be68c83514cd089ddb2f67e2b7ca3.svg";
export { ForwardRef as ReactComponent };